import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

// Hooks
import { useToggle } from 'Shared/utils/hooks';
import { useWorkspace } from 'Shared/utils/hooks/use-workspace';

// Selectors
import { getRecentUpdatesByWorkspaceUuid } from 'Shared/selectors/WorkspaceRecentUpdates.selectors';

// Actions
import { fetchRecentUpdates } from 'Shared/actions/workspaces';

// Helpers
import WorkspaceRecentUpdatesHelper from 'Shared/model_helpers/WorkspaceRecentUpdates.helper';

function useWorkspaceRecentUpdates() {
  const dispatch = useDispatch();
  const [isLoading, toggleIsLoading] = useToggle(false);

  const { workspaceId } = useParams();

  const workspaceUpdates = useSelector(state => getRecentUpdatesByWorkspaceUuid(state, { workspaceUuid: workspaceId }));
  const { workspace } = useWorkspace();
  const workspaceLastViewed = workspace.workspaceNotifications.viewedWorkspaceTime;
  const modifiedItemsUuids = workspace.workspaceNotifications.modifiedItemsUuids || [];
  const modifiedCommentsUuids = workspace.workspaceNotifications.modifiedCommentsUuids || [];

  useEffect(() => {
    toggleIsLoading();
    dispatch(fetchRecentUpdates({ workspaceId })).then(() => toggleIsLoading());
  }, [modifiedItemsUuids, modifiedCommentsUuids]);

  const response = workspaceUpdates.map(update => {
    const time = WorkspaceRecentUpdatesHelper.getTime(update);
    const meetingItemUuid = WorkspaceRecentUpdatesHelper.getMeetingItemUuid(update);
    const commentItemUuid = WorkspaceRecentUpdatesHelper.getWorkspaceCommentUuid(update);
    const showNewBadge =
      time > workspaceLastViewed &&
      (modifiedItemsUuids.findIndex(uuid => uuid === meetingItemUuid) > -1 ||
        modifiedCommentsUuids.findIndex(uuid => uuid === commentItemUuid) > -1);

    return update.merge({ isNew: showNewBadge });
  });

  return { workspaceRecentUpdates: response, isLoading: isLoading };
}

export default useWorkspaceRecentUpdates;
